module.exports = __webpack_public_path__ + "static/media/girl.cbf8f3a8.png";